import { useEffect, useState } from 'react';
import { surveyQuestionnairesApi } from '../surveyApi';
import type { SurveyQuestionnaire } from '../surveyTypes';

/**
 * A survey's live questionnaires, for Responses › Summary and › Question. A survey holds ONE
 * (the server refuses a second), so both views take the first and name it.
 */
export function useQuestionnaireOptions(surveyId: string): SurveyQuestionnaire[] | null {
  const [questionnaires, setQuestionnaires] = useState<SurveyQuestionnaire[] | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    surveyQuestionnairesApi
      .list(surveyId, { pageSize: 100, status: 'active', sort: 'createdAt:asc' }, controller.signal)
      .then((page) => {
        if (!controller.signal.aborted) setQuestionnaires(page.items);
      })
      .catch(() => {
        if (!controller.signal.aborted) setQuestionnaires([]);
      });

    return () => controller.abort();
  }, [surveyId]);

  return questionnaires;
}
